// The mention dictionary: EVERY username the store knows, as on Apple. Built from the loaded page's
// authors only, a mention of anyone who had not posted on screen — the reader included — drew as
// plain text (the same bug the native apps fixed on 2026-09-04, found again on the web 2026-10-11).
//
// It also carries the names mentions are DRAWN with in posted messages (lowercased username → full
// name, user request 2026-10-15), built by the worker in the same read. Both follow the `users`
// table, so a renamed person reads with the new name on the next render.
import { useMemo } from 'react';
import { data } from '../../bridge/client';
import { useLive } from '../hooks';

export interface MentionDirectory {
  knownUsernames: ReadonlySet<string>;
  /** Lowercased username → full name; only for people whose full name is not empty. */
  fullNames: ReadonlyMap<string, string>;
}

const EMPTY = { usernames: [] as string[], fullNames: {} as Record<string, string> };

export function useMentionDirectory(pageNames: ReadonlySet<string> | undefined, me: string | null): MentionDirectory {
  const { value } = useLive(() => data.call('mentionDirectory'), ['users'], []);
  const directory = value ?? EMPTY;
  const knownUsernames = useMemo(() => {
    const names = new Set<string>(directory.usernames);
    for (const n of pageNames ?? []) names.add(n);
    if (me) names.add(me);
    return names;
  }, [directory.usernames, pageNames, me]);
  const fullNames = useMemo(() => new Map(Object.entries(directory.fullNames)), [directory.fullNames]);
  return { knownUsernames, fullNames };
}
